import { TDevice, TDeviceDetails, TelemetryData } from "../../common/types";
import { TResponseItemWrapper, TResponseListWrapper } from "../../common/types/common";
import { apiClient } from "../apiClient";

export const getDeviceList = async ({ pagination: { pageSize, pageIndex }, sorting: { sortBy, isDescending }, filtering: { searchTerm } }): Promise<TResponseListWrapper<TDevice>> => {
    let sorting = sortBy ? `&sortBy=${encodeURIComponent(sortBy)}` : '';
    if (sortBy && isDescending) {
        sorting += `&isDescending=${encodeURIComponent(isDescending)}`;
    }

    const search = searchTerm ? `&searchTerm=${encodeURIComponent(searchTerm)}` : '';

    return apiClient.get(`/Device/GetDevices?pageSize=${encodeURIComponent(pageSize)}&pageNumber=${encodeURIComponent(pageIndex)}${sorting}${search}`);
};

export const getAllDevicesForUser = async (userId: string | number): Promise<TResponseItemWrapper<TDevice[]>> => {
    return apiClient.get(`/Device/GetDevicesForUser?userId=${encodeURIComponent(userId)}`);
};

export const getDeviceListForUser = async (userId, { pagination: { pageSize, pageIndex }, sorting: { sortBy, isDescending }, filtering: { searchTerm } }): Promise<TResponseListWrapper<TDevice>> => {
    let sorting = sortBy ? `&sortBy=${encodeURIComponent(sortBy)}` : '';
    if (sortBy && isDescending) {
        sorting += `&isDescending=${encodeURIComponent(isDescending)}`;
    }

    const search = searchTerm ? `&searchTerm=${encodeURIComponent(searchTerm)}` : '';

    return apiClient.get(`/Device/GetUserDevices?userId=${encodeURIComponent(userId)}&pageSize=${encodeURIComponent(pageSize)}&pageNumber=${encodeURIComponent(pageIndex)}${sorting}${search}`);
};

export const getDevice = async (deviceSerialNumber: string): Promise<TResponseItemWrapper<TDeviceDetails>> => {
    return apiClient.get(`/Device/GetDeviceDetail?deviceSerialNumber=${encodeURIComponent(deviceSerialNumber)}`);
};

export const addDevice = async ({ userId, deviceSerialNumber }) => {
    return apiClient.post(`/Device/AddDevice?userId=${encodeURIComponent(userId)}&deviceSerialNumber=${encodeURIComponent(deviceSerialNumber)}`);
};

export const deleteDevice = async ({ userId, deviceSerialNumber }) => {
    return apiClient.post(`/Device/RemoveDevice?userId=${encodeURIComponent(userId)}&deviceSerialNumber=${encodeURIComponent(deviceSerialNumber)}`);
};

export const assignDeviceOwner = async ({ userId, deviceSerialNumber }) => {
    return apiClient.post(`/Device/AddDeviceAsOwner?userId=${encodeURIComponent(userId)}&deviceSerialNumber=${encodeURIComponent(deviceSerialNumber)}`);
};

export const getDeviceRegistrationStatus = async (deviceSerialNumber) => {
    return apiClient.get(`/Device/RegistrationStatus?deviceSerialNumber=${encodeURIComponent(deviceSerialNumber)}`);
};

export const GetTotalsForUser = async (userId: string): Promise<TResponseItemWrapper<TDeviceDetails>> => {
    return apiClient.get(`/Device/GetTotalsForUser?userId=${encodeURIComponent(userId)}`);
};

export const GetDeviceTelemetryData = async (deviceSerialNumber: string): Promise<TResponseItemWrapper<TelemetryData>> => {
    return apiClient.get(`/Device/GetDeviceTelemetryData?deviceSerialNumber=${encodeURIComponent(deviceSerialNumber)}`);
};

export const GetAverageTelemetryData = async (jobId: string): Promise<TResponseItemWrapper<TelemetryData>> => {
    return apiClient.get(`/Job/GetAggregateTelemetryData?jobId=${encodeURIComponent(jobId)}`);
};

export const removeDeviceAsOwner = async ({ userId, deviceSerialNumber }) => {
    return apiClient.post(`/Device/RemoveDeviceAsOwner?userId=${encodeURIComponent(userId)}&deviceSerialNumber=${encodeURIComponent(deviceSerialNumber)}`);
};

export const addDeviceAsOperator = async ({ userId, deviceSerialNumber }) => {
    return apiClient.post(`/Device/AddDeviceAsOperator?userId=${encodeURIComponent(userId)}&deviceSerialNumber=${encodeURIComponent(deviceSerialNumber)}`);
};

export const removeDeviceAsOperator = async ({ userId, deviceSerialNumber }) => {
    return apiClient.post(`/Device/RemoveDeviceAsOperator?userId=${encodeURIComponent(userId)}&deviceSerialNumber=${encodeURIComponent(deviceSerialNumber)}`);
};

export const addDeviceAsDealer = async ({ userId, deviceSerialNumber }) => {
    return apiClient.post(`/Device/AddDeviceAsDealer?userId=${encodeURIComponent(userId)}&deviceSerialNumber=${encodeURIComponent(deviceSerialNumber)}`);
};

export const removeDeviceAsDealer = async ({ userId, deviceSerialNumber }) => {
    return apiClient.post(`/Device/RemoveDeviceAsDealer?userId=${encodeURIComponent(userId)}&deviceSerialNumber=${encodeURIComponent(deviceSerialNumber)}`);
};

export const getAllDevices = async (): Promise<TResponseItemWrapper<TDevice[]>> => {
    const result = await apiClient.get<TResponseListWrapper<TDevice>>(`/Device/GetDevices?pageSize=10000&pageNumber=1`);
    return {
        data: result.data?.data || null,
        success: result.success,
        errorMessage: result.errorMessage,
    } as TResponseItemWrapper<TDevice[]>;
};

export const getAllFusionDevices = async (): Promise<TResponseItemWrapper<TDevice[]>> => {
    return apiClient.get(`/Device/GetAllFusionDevices`);
};
